import EmptyState from 'components/ui/EmptyState';
import { useTariffContext } from 'context/tariff_state';
import { OrderStatus } from 'data/interfaces/Common';
import { CurrencySymbols, InterfaceLanguage, MonetizationTariff } from 'types/enums';
import { getLocaleFromLang } from 'utils/getLocaleFromLang';
import { addDays, format, parseISO } from 'date-fns';
import { useLocale, useTranslations } from 'shared/hooks/i18n';
import Image from 'next/image';
import { FC } from 'react';
import { ShopPages } from '..';
import styles from './style.module.scss';
import TariffCard from './TariffCard';

interface Props {
  setPage: (n: ShopPages) => void;
}

const MyTariffs: FC<Props> = ({ setPage }) => {
  const tariffContext = useTariffContext();
  const t = useTranslations();
  const lang = useLocale();
  const filteredOrders = tariffContext.orders.filter(
    (item) =>
      item.contents.tariff !== MonetizationTariff.Free &&
      (item.status === OrderStatus.PAID ||
        item.status === OrderStatus.USE ||
        item.status === OrderStatus.PARTIAL_PAYMENT),
  );

  const handleClickEmpty = () => {
    setPage(ShopPages.AllOffers);
  };

  if (filteredOrders.length === 0) {
    return (
      <EmptyState
        description={t('purchased_tariff_will_be_visible_in_this_section')}
        buttonText={t('set')}
        onClick={handleClickEmpty}
        icon={<Image src='/icons/empty-circle.svg' width={100} height={100} alt='empty circle' />}
      />
    );
  }

  return (
    <section className={styles.container}>
      {filteredOrders.map((product) => (
        <TariffCard
          setPage={setPage}
          key={product.id}
          id={product.id}
          isPartialPayment={
            product.status === OrderStatus.PARTIAL_PAYMENT && product.paymentTransactions !== null
          }
          {...product.contents}
          isActive
          currency={
            (product.contents?.meta?.currencySymbol as CurrencySymbols) ?? CurrencySymbols.USD
          }
          expiredIn={format(
            addDays(parseISO(product.createdAt), product.contents.productValidityPeriod),
            'dd.MM.yyyy',
            {
              locale: getLocaleFromLang(lang as InterfaceLanguage),
            },
          )}
        />
      ))}
    </section>
  );
};

export default MyTariffs;
